import Select from "react-select";
import PropTypes from 'prop-types';
import { Controller, useForm } from "react-hook-form";
import { useFormContext } from "context/Context";

const SearchSelect = ({
    name,
    label,
    options = [],
    placeholder = "Select option",
    rules = {},
    isDisabled = false,
    control,
    errors,
}) => {
    // const {
    //     control,
    //     formState: { errors }
    // } = useForm();

    return (
        <div className="search-select_dropdown">
            {label && <label className="form-label">{label}</label>}
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({ field }) => (
                    <Select
                        className="react-select-input"
                        classNamePrefix="rs"
                        options={options}
                        placeholder={placeholder}
                        isSearchable
                        isDisabled={isDisabled}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        menuPlacement="auto"
                        value={options.find(opt => opt.value === field.value) || null}
                        onChange={(opt) => field.onChange(opt?.value)}
                        styles={{
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 1056,
                            }),
                        }}
                    />
                )}
            />
            {errors?.[name] && (
                <div style={{fontSize:'13px',marginTop:'-20px'}} className="search-select-error">
                    {errors[name]?.message}
                </div>
            )}
        </div>
    )
};

SearchSelect.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        })
    ),
    placeholder: PropTypes.string,
    rules: PropTypes.object,
    isDisabled: PropTypes.bool,
};

export default SearchSelect;